import { v7 as uuidv7 } from "uuid";
/**
 * Generates a unique string ID that does not exist in the provided array of identifiable objects.
 * It continuously generates a random string until a unique one is found.
 *
 * @param {T[]} arr The array of objects to check for existing IDs.
 * @param {IdOptions} [options] An optional object containing the prefix and suffix for the ID.
 * @returns {string} A unique string ID.
 */
const generateUniqueIdForArrayElement = (arr, options = {}) => {
    const { prefix = "", suffix = "" } = options;
    let uniqueId = "";
    let isUnique = false;
    // Continue generating IDs until a unique one is found.
    while (!isUnique) {
        // Generate a random string ID.
        const randomPart = uuidv7();
        // Combine the optional prefix and suffix with the random part.
        const newId = `${prefix.trim()}${randomPart}${suffix.trim()}`;
        // Check if any object in the array has this newly generated ID.
        // The `.some()` method is efficient for this check as it stops as soon as it finds a match.
        const idExists = arr.some((item) => item.id === newId);
        // If the ID does not exist, it's unique.
        if (!idExists) {
            uniqueId = newId;
            isUnique = true;
        }
    }
    return uniqueId;
};
export { generateUniqueIdForArrayElement };
//# sourceMappingURL=string.js.map